<template>
  <div class="asd-form">
    <div class="asd-form-section">
      <div class="section-title">
        <h5>
          <i class="fas fa-plus-square"></i>
          Nový projekt
        </h5>
        <div class="section-title-controls">
          <ActiveButton class="asd-btn-confirm"
                        :click="create"
                        :disabled="disabled"
          >
            <i class="fas fa-save"></i>
          </ActiveButton>
        </div>
      </div>
      <label>Typ projektu</label>
      <Multiselect
        v-model="data.projectType.id"
        label="name"
        trackBy="id"
        valueByPath="id"
        :returnAsSingle="true"
        :options="projectTypes"
        :allowEmpty="false"
        :max="1"
      ></Multiselect>
      <PropertyForm
        v-if="data.projectType.id"
        v-model="data.propertyValues"
        :propertyKeys="projectPropertyKeys"
        :meta="{entityType: projectType}"
        editType="new"
      ></PropertyForm>
    </div>
  </div>
</template>

<script>
import { get, map, isString } from 'lodash'
import PropertyForm from 'CORE/components/form/property-form'
import Multiselect from 'CORE/components/utilities/vue-multiselect-ext'
import ActiveButton from 'CORE/components/form/active-button'
import Vue from 'vue'
import EventBus from 'CORE/bus'

export default {
    name: 'ProjectForm',
    components: {
        PropertyForm,
        Multiselect,
        ActiveButton,
    },
    props: {
        projectId: {
            type: String,
            required: false,
            default: _ => null,
        },
    },
    data: function() {
        return {
            data: {},
        }
    },
    computed: {
        disabled() {
            return !get(this.data, 'projectType.id', false)
        },
        projectTypes() {
            return this.$store.getters.projectTypes
        },
        projectPropertyKeys() {
            const projectType = this.$store.getters.projectTypeById(get(this.data, 'projectType.id'))
            return map(get(projectType, 'propertyType', []), pt => get(pt, 'key'))
        },
        projectType() {
            return this.$store.getters.projectTypeById(get(this.data, 'projectType.id'))
        },
    },
    created() {
        if (this.projectId === null) {
            this.data = {}
            Vue.set(this.data, 'id', this.$uuid.v4())
            Vue.set(this.data, 'projectType', { id: null })
            Vue.set(this.data, 'isTemplate', false)
            Vue.set(this.data, 'propertyValues', {})
        } else {
            this.data = this.$store.getters.getProjectById(this.projectId)
        }
        console.assert(
            isString(get(this.data, 'id')),
            'Invalid ID after data creation (not existing Project or invalid UUID creation)'
        )
    },
    methods: {
        async create() {
            try {
                await this.$store.dispatch('createProject', this.data)
                await this.$store.dispatch('projectsLoad')
                this.flash('Vytvořeno', 'success', {
                    timeout: 1500,
                })
                this.$emit('done')
            } catch (e) {
                EventBus.$emit('FLASH_ERROR', e)
            }
        },
    },
}
</script>
